import React from 'react';
import { Minus, Plus } from 'lucide-react';

const OptionCard = ({ option, value, onChange, disabled }) => {
  const isSelected = option.type === 'checkbox' ? value : value > 0;
  
  const handleCardClick = () => {
    if (disabled) return;
    
    if (option.type === 'checkbox') {
      onChange(!value);
    }
  };

  const handleCounterChange = (increment) => {
    if (disabled) return;
    
    const newValue = Math.max(0, Math.min(option.max || 999, value + increment));
    onChange(newValue);
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-FR').format(price);
  };

  return (
    <div
      className={`border-2 rounded-lg p-4 cursor-pointer transition-all ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      } ${
        isSelected
          ? 'border-[#fa6800] bg-[#fff5ee]'
          : 'border-[#d8dde5] bg-white hover:border-[#fa6800] hover:bg-[#fff5ee]'
      }`}
      onClick={option.type === 'checkbox' ? handleCardClick : undefined}
      data-testid={`option-card-${option.id}`}
    >
      <div className="mb-3">
        <h3 className="font-medium text-[#2d2d2d] leading-tight mb-2">
          {option.title.split(' ').length > 2 ? (
            <>
              {option.title.split(' ').slice(0, 2).join(' ')}<br />
              {option.title.split(' ').slice(2).join(' ')}
              {option.priceUnit && <span className="text-sm font-medium text-[#2d2d2d]"> {option.priceUnit}</span>}
            </>
          ) : (
            <>
              {option.title}
              {option.priceUnit && <span className="text-sm font-medium text-[#2d2d2d]"> {option.priceUnit}</span>}
            </>
          )}
        </h3>
        <p className="text-sm text-[#647687] leading-relaxed mb-3">
          {option.details}
        </p>
        
        {option.dependency && (
          <p className="text-xs italic text-[#647687] mb-3">
            {option.dependencyText}
          </p>
        )}
      </div>

      {option.type === 'checkbox' ? (
        <div className="text-center">
          <span className="text-sm font-medium text-[#2d2d2d]">
            {option.selectionText}
          </span>
        </div>
      ) : (
        <div className="flex items-center justify-center gap-2" onClick={(e) => e.stopPropagation()}>
          <button
            className="counter-btn"
            onClick={() => handleCounterChange(-1)}
            disabled={disabled || value === 0}
            data-testid={`counter-minus-${option.id}`}
          >
            <Minus size={16} />
          </button>
          <span className="counter-value" data-testid={`counter-value-${option.id}`}>
            {value}
          </span>
          <button
            className="counter-btn"
            onClick={() => handleCounterChange(1)}
            disabled={disabled || value >= (option.max || 999)}
            data-testid={`counter-plus-${option.id}`}
          >
            <Plus size={16} />
          </button>
        </div>
      )}
    </div>
  );
};

export default OptionCard;